export default "__VITE_ASSET__4234a87f__"